import { s } from '@/theme/tokens';
import { Box, Surface } from '@/ui/primitives';
import {
  buildChartPanelSurfaceSx,
  buildMetricsChartPanelFrameContentSx,
  buildMetricsChartPanelFrameHeaderSx,
  metricsChartPanelFrameSurfaceSx,
} from './chartPanelSurfaceSx';
import type { SxProps, Theme } from '@/ui/primitives';
import type { ReactElement, ReactNode } from 'react';

type MetricsChartPanelFrameSx = Exclude<
  Extract<SxProps<Theme>, readonly unknown[]>[number],
  boolean
>;

type MetricsChartPanelFrameProps = {
  height: number;
  header: ReactNode;
  children: ReactNode;
  headerPaddingX?: string;
  headerPaddingTop?: string;
  headerPaddingBottom?: string;
  contentPaddingX?: string;
  contentPaddingTop?: string;
  contentPaddingBottom?: string;
  headerSx?: MetricsChartPanelFrameSx;
  contentSx?: MetricsChartPanelFrameSx;
};

export const MetricsChartPanelFrame = ({
  height,
  header,
  children,
  headerPaddingX = s('lg'),
  headerPaddingTop = s('md'),
  headerPaddingBottom = s('xs'),
  contentPaddingX = s('none'),
  contentPaddingTop = s('none'),
  contentPaddingBottom = s('none'),
  headerSx,
  contentSx,
}: MetricsChartPanelFrameProps): ReactElement => (
  <Surface
    padding="none"
    radius="card"
    sx={[...buildChartPanelSurfaceSx({ height }), metricsChartPanelFrameSurfaceSx]}
  >
    <Box
      sx={[
        buildMetricsChartPanelFrameHeaderSx({
          headerPaddingBottom,
          headerPaddingTop,
          headerPaddingX,
        }),
        ...(headerSx ? [headerSx] : []),
      ]}
    >
      {header}
    </Box>
    <Box
      sx={[
        buildMetricsChartPanelFrameContentSx({
          contentPaddingBottom,
          contentPaddingTop,
          contentPaddingX,
        }),
        ...(contentSx ? [contentSx] : []),
      ]}
    >
      {children}
    </Box>
  </Surface>
);
